<template>
  <form @submit.prevent="handleRegister" autocomplete="off">
    <div class="form-horizontal" id="validate-form">
      <div class="col-xs-12">
        <div
          v-if="ErrorMessage"
          class="alert-danger alert visibility"
          role="alert"
        >
          {{ ErrorMessage }}
        </div>
        <div
          v-if="SuccessMessage"
          class="alert-info alert visibility"
          role="alert"
        >
          {{ SuccessMessage }}
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group mb-md">
          <div class="input-group">
            <input
              type="password"
              class="form-control"
              v-model="register.password"
              name="password"
              placeholder="Password"
              v-validate="'required|min:8|verify_password'"
              ref="password"
            />
            <span v-if="errors.has('password')">
              {{ errors.first('password') }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group mb-md">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Conform Password"
              v-model="register.ConformPassword"
              v-validate="'required|confirmed:password'"
              type="password"
              name="password_confirmed"
              data-vv-as="password confirmation"
            />

            <span v-if="errors.has('password_confirmed')">
              {{ errors.first('password_confirmed') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <div class="clearfix">
        <button
          type="submit"
          class="btn btn-primary submitbtn btn-raised pull-right"
          :disabled="loading"
        >
          <span> Change Password </span>
        </button>
      </div>
  <router-link to="/login">Login</router-link>
      
    </div>
  </form>
</template>

<script>
import OpenAuth from '../../services/auth.service';

import { Validator } from 'vee-validate';

Validator.extend('verify_password', {
  getMessage: (field) =>
    `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: (value) => {
    var strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
    );
    return strongRegex.test(value);
  },
});
function initialState() {
  return {
    password: '',
    ConformPassword: '',
  };
}
export default {
  name: 'PasswordResetSetPassword',
  data() {
    return {
      loading: false,
      register: initialState(),
      ErrorMessage: '',
      SuccessMessage: '',
    };
  },
  methods: {
    handleRegister(e) {
      this.message = '';
      this.$validator.validateAll().then((res) => {
        if (!res) {
          return false;
        } else {
          let storeData = JSON.parse(localStorage.getItem('passwordReset'));
          if(storeData== null) {
            setTimeout(() => (this.ErrorMessage = "Opps, Please start again!"), 5000);
            return false;
          }
          console.log(storeData.token);
          //   let formData = {};
          // formData['UserCode'] = UserCode;
          OpenAuth.putToken(
            'kspgAPI/commonData/resetPasswordPasswordSet',
            this.register,
            storeData.token
          ).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              // this.loading = false;
              // on success reset values
              if (response.data.status) {
                /*Get Partner type and set it again after reset */
                const pt = this.register.partnerType;
                this.resetWindow();
                this.register.partnerType = pt;
                /*Clear Validation */
                this.$nextTick(() => {
                  this.errors.clear();
                  this.$nextTick(() => {
                    this.$validator.reset();
                  });
                });
                setTimeout(() => (this.SuccessMessage = response.data.message), 5000);
                localStorage.removeItem('passwordReset');
              }
            },
            (error) => {
              this.loading = false;

              this.ErrorMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
        }
      });
      // Hide Messages
      setTimeout(() => (this.ErrorMessage = false), 5000);
      setTimeout(() => (this.SuccessMessage = false), 5000);
    },
    resetWindow: function () {
      Object.assign(this.$data.register, initialState());
    },
  },
};
</script>
